import { computed, observable, makeObservable } from "mobx";
import { QuizObject } from "../quiz_objects/quiz-object";

export default class UserSubject {
    public slug: string = "";
    public _id: string;
    public description: string = "";
    public image_url: string = "";
    public title: string = "";
    public user: string = "";
    public complete: boolean = true;
    public enabled: boolean = true;
    public public: boolean = false;
    public quizObjects: QuizObject[] = [];
    public quizObjectCount: number = 0;

    constructor(slug: string, profileSubject: any, subject: any) {
        makeObservable(this, {
            slug: observable,
            _id: observable,
            description: observable,
            image_url: observable,
            title: observable,
            user: observable,
            complete: observable,
            enabled: observable,
            public: observable,
            quizObjects: observable,
            quizObjectCount: observable,
            hash_key: computed,
            addObject: true,
        });

        if (profileSubject) {
            this.title       = subject.title;
            this.user        = subject.user;
            this.enabled     = profileSubject.enabled;
            this.description = subject.description;
            this.public      = subject.public;
            if (subject) {
                this.image_url       = subject.image_url;
                this.quizObjectCount = subject.quizObjectCount;
            } else {
                this.quizObjectCount = 0;
            }
        }
        this.slug     = subject.slug;
        this._id       = subject._id;
        this.complete = false;
    }

    get hash_key() {
        return `${this.user}/${this.slug}`;
    }

    public addObject(object: any) {
        this.quizObjects.push(new QuizObject(object.slug, object));
    }

}
